export class AutoTableColumnDefinition {
    column: string;
    columnTitle: string;
    isSticky?: boolean;
    aligment?: string;
    paddingRight?: string;
    order?: Number
}
